import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {PersonLogin, RoleName} from '../person/person-login';
import {PersonLoginService} from '../services/person-login-service';
import {ProductService} from '../services/product-service';
import {StringUtils} from '../utils/string-utils';
import {ProductHeader} from './product-header';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {FormsModule} from '@angular/forms';
import {forkJoin, Observable} from "rxjs";

@Component({
    selector: 'product-header',
    templateUrl: './product-header.component.html',
    styleUrls: ['./product-header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatProgressSpinner, RouterLink]
})
export class ProductHeaderComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly productService = inject(ProductService);
  private readonly router = inject(Router);


  public personLogin!: PersonLogin;
  public readonly searchResults = signal<ProductHeader[]>(undefined!);
  public searchTerm!: string;
  public readonly isBusy = signal<boolean>(undefined!);
  public readonly errorMessage = signal<string>(undefined!);
  public readonly searchComplete = signal<boolean>(undefined!);

  public newProduct(): void {
    this.router.navigate(['product/new']);
  }

  public search(): void {
    if (!this.isBusy() && this.searchTerm && this.searchTerm.length >= 3) {
      this.searchResults.set([]);
      this.clearStatus();
      let getCalls: Observable<ProductHeader[]>[] = [];
      this.personLoginService.getBrandIDs().forEach(brandID => {
        const observable = this.productService.search(this.searchTerm, brandID);
        getCalls.push(observable);
        observable.subscribe(async (results) => {
          for (var ph of results) {
            ph.brandID = brandID;
          }
          if (this.searchResults() && this.searchResults().length > 0) {
            this.searchResults.update(current => [...current, ...results]);
          } else {
            this.searchResults.set(results);
          }
        });
      });

      forkJoin([...getCalls]).subscribe(results => {
        this.isBusy.set(false);
        this.searchComplete.set(true);
      });

    }
  }

  public handleKeyUp(keyEvent: any): void {
    if (keyEvent.keyCode === 13) {
      this.search();
    }
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.searchComplete.set(false);
    this.searchResults.set(null!);
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  ngOnInit(): void {
    if (!this.personLoginService.hasRole(RoleName.IT)) {
      this.router.navigate(['main']);
    }
    this.personLogin = this.personLoginService.getCachedLogin()!;
  }

}


